<template>
  <div class="my-integral-wrap">
    <div class="rule-card" v-if="showRule">
      <div class="rule-title">
        <div class="my-breadcrumb pdt10 pdb20">
          <span>我的位置：</span>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/user/index' }">账号管理</el-breadcrumb-item>
            <el-breadcrumb-item>我的积分</el-breadcrumb-item>
            <el-breadcrumb-item>积分规则</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
      <div class="rule-content" v-html="page.content"></div>
      <el-button class="my-btn" @click="showRule = false" style="margin: 20px auto;display: block;">
        返回
      </el-button>
    </div>
    <div v-if="!showRule">
      <div class="integral-header">
        <div class="integral-info">

          <div class="integral-num">
            <div class="title mgb5">我的积分</div>
            <div class="val mgt5">{{ user.integral }}</div>
            <div class="btn-list mgt5">
              <router-link class="btn flex-cc" :to="{ path: '/withdraw/index' }">提现</router-link>
            </div>
          </div>

          <div class="rule" @click="showRule = true">积分规则</div>
        </div>
        <img src="~@/assets/images/store_entry_bg.png" class="store_entry_img" alt="">
      </div>
      <div class="integral-detail">
        <div class="data-type-wrap">
          <div class="item" :class="[activeIndex == 0 ? 'active' : '']">积分收支明细</div>
        </div>

        <el-table :data="list" v-loading="loading" element-loading-text="给我一点时间" :empty-text="emptyText" border fit
          highlight-current-row>
          <el-table-column label="变更前" align="center" minWidth="150" prop="before">
          </el-table-column>
          <el-table-column label="变更数量" align="center" width="150" prop="change">
          </el-table-column>
          <el-table-column label="变更后" align="center" width="150" prop="after">
          </el-table-column>
          <el-table-column label="变更时间" align="center" minWidth="180" prop="create_time">
          </el-table-column>
          <el-table-column label="备注" align="center" width="200" prop="remark">
          </el-table-column>
        </el-table>

        <div class="flex-row mgt20">
          <div class="flex-grow-1"></div>
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.pagesize"
            layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPageDetail } from "@/api/page";
import { getInfo, getIntegralList } from "@/api/user";
export default {
  name: 'UserIntegral',
  components: {

  },
  data() {
    return {
      loading: false,
      showRule: false,
      activeIndex: 0,
      emptyText: '暂无数据',
      listQuery: {
        type: 1,
        page: 1,
        pagesize: 10
      },
      list: [],
      total: 0,
      user: {},
      page: {},
    };
  },
  computed: {

  },
  created() {
    this.getInfo();
    this.getPageDetail()
    this.getList();
  },
  methods: {
    getPageDetail() {
      getPageDetail({ 'alias': 'integral' }).then(res => {
        this.loading = false;
        this.page = res.data;
      }).catch((err) => {

      });
    },
    getInfo() {
      getInfo({}).then(res => {
        this.loading = false;
        this.user = res.data;
      }).catch((err) => {

      });
    },
    // 获取列表
    getList() {
      this.loading = true;
      const _listQuery = Object.assign({}, this.listQuery);
      getIntegralList(_listQuery)
        .then((response) => {
          this.list = response.data.list;
          this.total = response.data.count * 1;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 查询
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    // 更改每页行数
    handleSizeChange(val) {
      this.listQuery.pagesize = val;
      this.getList();
    },
    // 更改页码
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
  }
};
</script>

<style lang="scss" scoped>
.my-integral-wrap {
  width: 100%;
  margin-top: 16px;
  background: #FFFFFF;
  box-shadow: 0px 0px 10px 1px rgba(111, 127, 132, 0.102);
  border-radius: 2px;

  .integral-header {
    width: 100%;
    box-sizing: border-box;
    border-bottom: 1px solid #CCD7DB;
    padding: 36px 33px;

    .integral-info {
      display: flex;
      justify-content: space-between;
      margin-bottom: 9px;

      .integral-num {
        .title {
          font-size: 16px;
          font-weight: 400;
          color: #222222;
        }

        .val {
          font-size: 24px;
          font-weight: bold;
          color: #222222;
          margin-top: 5px;

          &>i {
            font-size: 32px;
          }
        }

        .btn-list {
          display: flex;
          align-items: center;

          .btn {
            width: 60px;
            height: 25px;
            line-height: 25px;
            border-radius: 3px;          
            font-size: 14px;
            color: #FFF;
            background: #00b4e8;
          }
        }
      }

      .rule {
        font-size: 16px;
        font-weight: 400;
        color: #222222;
        cursor: pointer;
      }
    }

    .store_entry_img {
      width: 100%;
    }
  }

  .integral-detail {
    width: 100%;
    padding: 28px 32px 44px 32px;
    box-sizing: border-box;

    .data-type-wrap {
      display: flex;
      align-items: center;
      column-gap: 20px;
      margin-bottom: 27px;

      .active {
        color: #FFFFFF !important;
        background: #00B4E8 !important;
      }

      .item {
        font-size: 16px;
        font-weight: 400;
        color: #00B4E8;
        background: #00b6e81a;
        padding: 7px 17px;
        cursor: pointer;
      }
    }

    .table {
      border: 1px solid #DCE5EB;
    }

    th {
      text-align: center;
      padding: 13px 0;
    }

    thead {
      tr {
        th {
          background-color: #E9F3F6;
        }

        th:nth-child(1) {
          width: 54%;
        }

        th:nth-child(2) {
          width: 12%;
        }

        th:nth-child(3) {
          width: 22%;
        }

        th:nth-child(4) {
          width: 12%;
        }
      }
    }

    tbody {
      &>.empty {
        position: relative;
        height: 43px;

        &>th {
          position: absolute;
          width: 100%;
          height: 43px;
          font-size: 15px;
          color: #999999;
        }
      }
    }
  }

  .rule-card {
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 1px rgba(111, 127, 132, 0.102);
    border-radius: 2px;
    padding: 30px;

    .rule-title {
      width: 100%;
      padding: 0px 25px 0 25px;
      border-bottom: 1px solid #CCD7DB;
    }

    .rule-content {
      width: 100%;
      padding: 27px 37px 41px 37px;

      .q-title {
        font-size: 16px;
        font-weight: 300;
        color: #222222;
        font-weight: bold;
        margin-bottom: 10px;
      }

      .q-answer {
        font-size: 16px;
        font-weight: 300;
        color: #222222;
        font-weight: lighter;
        margin-bottom: 40px;
        line-height: 26px;
      }
    }
  }
}
</style>
